<template>
  <v-row>
    <v-col
      cols="12"
      sm="5"
      md="3"
      class="pb-5 pb-sm-0"
    >
      <BaseButton
        class="secondary white--text"
        width="100%"
        :to="{ name: 'edit broker' }"
      >
        <v-icon class="pr-2">
          fa-plus
        </v-icon>
        INCLUIR CORRETORA
      </BaseButton>
    </v-col>
    <v-col cols="12">
      <BaseDataTable
        :headers="header"
        :items="listBrokers"
        no-data-text="Nenhuma Corretora foi encontrada"
        loading-text="Carregando Corretoras..."
        :options.sync="options"
        class="broker-table"
        @click:row="editBroker"
      >
        <template v-slot:[`item.registro_susep`]="{ item }">
          <div :class="borderColor(item)">
            <div class="broker-table__padding">
              {{ item.registro_susep }}
            </div>
          </div>
        </template>
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nome }}
        </template>
        <template v-slot:[`item.cnpj`]="{ item }">
          {{ item.cnpj }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          {{ item.status }}
        </template>
      </BaseDataTable>
    </v-col>
  </v-row>
</template>
<script>
import { api } from "@/api";

const tableHeaders = [
  { text: "Susep", value: "registro_susep", sortable: true },
  { text: "Nome", value: "nome", sortable: true },
  { text: "Cnpj", value: "cnpj", sortable: true },
  { text: "Status", value: "status", sortable: true },
];
const colorByStatus = [
  { color: "green", status: "ATIVO" },
  { color: "pink", status: "INATIVO" }
];

export default {
  data: () => ({
    filter: "",
    header: tableHeaders,
    listColorByStatus: colorByStatus,
    listBrokers: [],
    api,
    options: {
      groupBy: [],
      groupDesc: [],
      itemsPerPage: 5,
      multiSort: false,
      mustSort: false,
      page: 1,
      sortBy: [],
      sortDesc: []
    }
  }),
  
  async created() {
      this.listBrokers = await this.fetchData();
  },
  computed: {

  },
  methods: {
    async fetchData() {
        return (await this.api.get("/v1/corretoras")).data;
    },
    editBroker(item) {
        this.$router.push({
          name: "edit broker",
          params: { id: item.id }
        });
    },
    borderColor(item) {
        const status = this.listColorByStatus.find(x => x.status == item.status);
        return `broker-table__border-${status.color}`;
    },
  },
};
</script>
<style lang="sass">
.broker-table__
  &border-green
    border-left: 5px solid #49DCBB
  &border-pink
    border-left: 5px solid #EF5350
  &padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
.broker-table
  tbody tr
    cursor: pointer
.broker-table.v-data-table.theme--light
  tbody tr td:first-child
    padding: 2px 0px !important
</style>
